const LINK_ITEM_CLASSES_PREFIX = "LinkItem";

export const LINK_ITEM_CLASSES = {
  linkItem: `${LINK_ITEM_CLASSES_PREFIX}-linkItem`,
  anchor: `${LINK_ITEM_CLASSES_PREFIX}-anchor`,
};
